'use client'
import { FC } from 'react'
import { Intercom } from 'react-live-chat-loader'

import { colors } from '#styles'

const IntercomWrapper: FC = () => {
  return <Intercom color={colors.greenAccent} />
}
export default IntercomWrapper
